// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageContainer_pLWR1{font-family:\"Square Market\";text-align:center}.Divider_3dLi6{border:1px solid #e7e7e7;border-top:0}.WarningContainer_M5hsQ{background-color:#fff;border:1px solid #d4d4d4;box-shadow:0 0 41px -8px #edeaed;display:inline-block;font-size:14px;margin:10% auto 0;padding:40px 40px 20px;text-align:center}.Header_aQfNh{color:#363b3e;font-size:45px;font-weight:500;margin:26px}.Error_x7cY4{color:#9ba0a3;margin:0 0 35px}.CheckUrl_\\+uzpJ,.Otherwise_qFnlI{color:#666c70}.CheckUrl_\\+uzpJ{font-weight:500;margin:0 0 20px}.Otherwise_qFnlI{margin-top:0}.Logo_Z90-u{width:82px}.BottomContent_V9SCR{display:inline-block;height:120px;line-height:120px}.BottomContent_V9SCR>span{display:inline-block;line-height:normal;vertical-align:middle}a{color:#2990ea;text-decoration:inherit}@media (max-width:550px){.warning-container_PBeGf{width:80%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PageContainer": "PageContainer_pLWR1",
	"Divider": "Divider_3dLi6",
	"WarningContainer": "WarningContainer_M5hsQ",
	"Header": "Header_aQfNh",
	"Error": "Error_x7cY4",
	"CheckUrl": "CheckUrl_+uzpJ",
	"Otherwise": "Otherwise_qFnlI",
	"Logo": "Logo_Z90-u",
	"BottomContent": "BottomContent_V9SCR",
	"warning-container": "warning-container_PBeGf"
};
module.exports = ___CSS_LOADER_EXPORT___;
